import {DOCUMENT} from "@angular/common";
import {DestroyRef, Inject, Injectable} from "@angular/core";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {Meta, Title} from "@angular/platform-browser";
import {TranslateService} from "@ngx-translate/core";
import {merge} from "rxjs";
import {AuthService} from "../modules/auth/services/auth.service";
import {User} from "../modules/auth/models/User";
import {resolveAuthLocale} from "../modules/auth/utils/auth-locale.util";

@Injectable({
  providedIn: "root",
})
export class TranslationService {
  private user: User | null = null;

  constructor(
    private readonly authService: AuthService,
    private readonly translate: TranslateService,
    title: Title,
    meta: Meta,
    @Inject(DOCUMENT) document: Document,
    destroyRef: DestroyRef
  ) {
    this.translate.setDefaultLang("en");

    merge(this.translate.onLangChange, this.translate.onTranslationChange)
      .pipe(takeUntilDestroyed(destroyRef))
      .subscribe(({lang, translations}) => {
        if (lang !== this.translate.currentLang) {
          return;
        }

        document.documentElement.lang = lang;
        const translatedTitle: unknown = translations["META_TITLE"];
        const translatedDescription: unknown = translations["META_DESCRIPTION"];
        if (typeof translatedTitle === "string") {
          title.setTitle(translatedTitle);
        }
        if (typeof translatedDescription === "string") {
          meta.updateTag({name: "description", content: translatedDescription});
        }
      });

    this.authService.user$.subscribe((user: User | null) => {
      this.user = user;
      this.translate.use(this.user?.language ?? resolveAuthLocale().language);
    });
  }
}
